/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import CmsContext from 'context/CmsContext';
import { ModalContext } from 'App';
import Select from 'react-select';
import Address from 'modules/common/address/Address';
import Citizenship from 'modules/BPLS/container/applications/components/Citizenship';
import * as c from '../constant';
import * as actions from '../actions';

function UpdateBusinessState({
  id,
  data,
  updateBusinessState,
  updating,
  getItem,
  // refreshList,
}) {
  const [formData, setFormData] = useState({});

  const cmsContext = useContext(CmsContext);
  // const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const setModal = useContext(ModalContext);

  useEffect(() => {
    setFormData({
      kind_of_ownership: _.get(data, 'kind_of_ownership'),
      business_name: _.get(data, 'business_name'),
      trade_name: _.get(data, 'trade_name'),
      incharge_first_name: _.get(data, 'incharge_first_name'),
      incharge_middle_name: _.get(data, 'incharge_middle_name'),
      incharge_last_name: _.get(data, 'incharge_last_name'),
      incharge_suffix_name: _.get(data, 'incharge_suffix_name'),
      main_office_region_code: _.get(data, 'main_office_region_code'),
      main_office_province_code: _.get(data, 'main_office_province_code'),
      main_office_municipality_code: _.get(data, 'main_office_municipality_code'),
      main_office_barangay_code: _.get(data, 'main_office_barangay_code'),
      main_office_zip_code: _.get(data, 'main_office_zip_code'),
      main_office_street: _.get(data, 'main_office_street'),
      telephone_no: _.get(data, 'telephone_no'),
      email_address: _.get(data, 'email_address'),
      no_of_employees: _.get(data, 'no_of_employees'),
      area: _.get(data, 'area'),
      nationality: _.get(data, 'nationality'),
      dti_no: _.get(data, 'dti_no'),
      sec_no: _.get(data, 'sec_no'),
      cda_no: _.get(data, 'cda_no'),
    })
  }, [data])

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData
    };

    Object.keys(args).forEach((item) => {
      if(_.isEmpty(_.get(args, `${item}`))) {
        delete args[item] 
      }
    })
    updateBusinessState(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChangeBusinessAddress = e => {
    setFormData({
      ...formData,
      main_office_region_code: e.target.value.region_code,
      main_office_province_code: e.target.value.province_code,
      main_office_municipality_code: e.target.value.municipality_code,
      main_office_barangay_code: e.target.value.barangay_code,
      main_office_street: e.target.value.street || '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div>
          <b>
            Before You Continue:
          </b>
          <p>
            Updates made here will affect only the current transaction. Business Module records and fee calculations will not be updated.
          </p>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Information
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Type:
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('kind_of_ownership')}
                options={c.KIND_OF_OWNERSHIP}
                value={
                  c.KIND_OF_OWNERSHIP.find(
                    item =>
                      _.get(formData, 'kind_of_ownership') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Number:
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="dti_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'dti_no') || ''}
                />
              </div>
            )}
            {['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
              _.get(formData, 'kind_of_ownership')
            ) > -1 && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  SEC Registration Number:
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="sec_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'sec_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'COOPERATIVE' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  CDA Registration Number:
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="cda_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'cda_no') || ''}
                />
              </div>
            )}
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'business_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Trade Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="trade_name"
                onChange={onChange}
                value={_.get(formData, 'trade_name') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Taxpayer&apos;s Information
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                First Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_first_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_first_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Middle Name:{' '}
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_middle_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_middle_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Last Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="incharge_last_name"
                onChange={onChange}
                value={_.get(formData, 'incharge_last_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Suffix:
              </label>
              <Select
                name="incharge_suffix_name"
                placeholder="Select Suffix"
                onChange={handleOnChangeSelect('incharge_suffix_name')}
                options={c.EXTENSION_NAMES}
                value={
                  c.EXTENSION_NAMES.find(
                    item =>
                      _.get(formData, 'incharge_suffix_name') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Telephone Number:
              </label>
              <InputMask
                className="form-control"
                // mask="99-9999-9999"
                // alwaysShowMask
                type="text"
                name="telephone_no"
                onChange={onChange}
                value={_.get(formData, 'telephone_no') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Email Address:
              </label>
              <input
                className="form-control"
                type="text"
                name="email_address"
                onChange={onChange}
                value={_.get(formData, 'email_address') || ''}
              />
            </div>
            {(_.get(formData, 'kind_of_ownership') === 'CORPORATION' ||
              _.get(formData, 'kind_of_ownership') === 'ONE PERSON CORPORATION' ||
              _.get(formData, 'kind_of_ownership') === 'PARTNERSHIP') && (
              <div className="col-6 form-group">
                <label className="form-label mb-0">
                    Country of Citizenship
                </label>
                <Citizenship
                  name="nationality"
                  onChange={onChange}
                  value={_.get(formData, 'nationality') || ''}
                />
              </div>
            )}
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Area:
              </label>
              <input
                className="form-control"
                type="number"
                name="area"
                onChange={onChange}
                value={_.get(formData, 'area') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                No. of Employees:
              </label>
              <input
                className="form-control"
                type="number"
                name="no_of_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Main Office Address
        </div>
        <div className="container-fluid">
          {/* {_.get(CMS_COMPONENTS, 'BUSINESS_ADDRESS') && (
            <Address
              value={{
                region_code: _.get(formData, 'main_office_region_code') || '',
                province_code:
                  _.get(formData, 'main_office_province_code') || '',
                municipality_code:
                  _.get(formData, 'main_office_municipality_code') || '',
                barangay_code:
                  _.get(formData, 'main_office_barangay_code') || '',
              }}
              type="Business"
              onChange={onChangeBusinessAddress}
              region_name="main_office_region_code"
              province_name="main_office_province_code"
              municipality_name="main_office_municipality_code"
              barangay_name="main_office_barangay_code"
              name="main_office"
              withStreet={false}
              removeLabel
            />
          )} */}
          <Address
            value={{
              region_code: _.get(formData, 'main_office_region_code') || '',
              province_code:
                _.get(formData, 'main_office_province_code') || '',
              municipality_code:
                _.get(formData, 'main_office_municipality_code') || '',
              barangay_code:
                _.get(formData, 'main_office_barangay_code') || '',
            }}
            onChange={onChangeBusinessAddress}
            type="Business"
            region_name="main_office_region_code"
            province_name="main_office_province_code"
            municipality_name="main_office_municipality_code"
            barangay_name="main_office_barangay_code"
            name="main_office"
            withStreet={false}
            removeLabel
          />
          <div className="row mt-2">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                ZIP Code:
              </label>
              <InputMask
                className="form-control"
                type="text"
                mask="9999"
                name="main_office_zip_code"
                onChange={onChange}
                value={_.get(formData, 'main_office_zip_code') || ''}
              />
            </div>
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Unit/Room No./Floor, Building Name, House No., Street Name:{' '}
              </label>
              <input
                className="form-control"
                type="text"
                name="main_office_street"
                onChange={onChange}
                value={_.get(formData, 'main_office_street') || ''}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>{' '}
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateBusinessState.defaultProps = {
  id: '',
};

UpdateBusinessState.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  // refreshList: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string,
  updateBusinessState: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BUSINESS_STATE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateBusinessState);
